import type { Room } from "../../../interfaces/interfaces";

export default [
  {
    name: "Område 1",
    id: "360c706b-1cd6-4c97-b56c-d5693ef33ede",
  },
  {
    name: "Område 2",
    id: "a0516a49-397f-42f5-b19e-532e6b6ee009",
  },
  {
    name: "Område 3",
    id: "4c9b7d91-6543-4f4d-98a0-1c61505f8afe",
  },
  {
    name: "Område 3:2",
    id: "e098be1e-c2c9-4d14-b1fe-d696e1033554",
  },
  {
    name: "Område 3:3",
    id: "bc045581-1cf4-4d54-8df8-d04c4d173bb8",
  },
  {
    name: "Område 4",
    id: "540dfbb4-6eee-4fda-8ee9-8acbea85f863",
  },
  {
    name: "Område 4:2",
    id: "c3da3abb-bae6-44b0-8c38-d616a3cde6b3",
  },
  {
    name: "Område 5",
    id: "eabc897c-0000-4e62-9abb-8c26b6ceed1b",
  },
  {
    name: "Område 7",
    id: "54716e7c-b7fa-4c74-8d0e-145451a9274a",
  },
  {
    name: "Område 8",
    id: "653be46c-6036-4ae4-9f49-1a9bba2eaf85",
  },
  {
    name: "Område 9",
    id: "5a16aee9-7af8-4ff3-8a5e-dbfc8119fa73",
  },
  {
    name: "Område 10",
    id: "29e76602-8bee-4de6-b1cd-334e6e88dcdf",
  },
  {
    name: "Område 11",
    id: "7620439a-a54a-4447-a200-28dc5a852867",
  },
  {
    name: "Område 11:2",
    id: "800f883a-bcbe-4768-9d0a-a32164bba536",
  },
  {
    name: "Område 12",
    id: "3c4f2e6f-8147-4043-bf7c-a8cb5891e868",
  },
  {
    name: "Område 13",
    id: "2e0d2add-249c-4bfd-b884-7ef35665bacb",
  },
  {
    name: "Område 14",
    id: "98930f4d-4c1b-4e3e-b07d-c26819cd7f07",
  },
  {
    name: "Område 15",
    id: "09d597f8-a2c4-40f0-bd6a-3acdbb7d9b7e",
  },
  {
    name: "Område 16",
    id: "43071551-f1be-4ba1-a9bb-4c65099a25ae",
  },
  {
    name: "Område 16:2",
    id: "c87a7ff4-fdcd-45cb-9e1b-dbb2834f27e3",
  },
  {
    name: "Område 17",
    id: "21f1a300-601c-4ff6-a04f-e6bd460c3cee",
  },
  {
    name: "Område 18",
    id: "2d1f0d9e-ead3-444b-b0fb-ed7835a77788",
  },
  {
    name: "Område 19",
    id: "267506b2-e6f6-4c5d-a44a-478aa0cbfe98",
  },
  {
    name: "Område 20",
    id: "15d0cf0c-6e26-41a1-8e2f-cffce723d943",
  },
  {
    name: "Område 21",
    id: "6747ce29-e725-49e6-9579-5c1557c8558c",
  },
  {
    name: "Område 22",
    id: "7c4c5d0d-94a8-4c44-b41d-fe17cd967388",
  },
  {
    name: "Område 23",
    id: "c702736a-e672-44fb-9528-8184600b1a5d",
  },
  {
    name: "Område 24",
    id: "e3a8bddb-c0f9-48fb-867f-a11581786533",
  },
  {
    name: "Område 25",
    id: "77dfcf82-0e1f-4544-901d-4d236b488164",
  },
  {
    name: "Område 26",
    id: "caeb5781-0052-446f-bd72-6bf6683e5864",
  },
] as Room[];
